<template>
  <section>
    <v-container grid-list-md pt-12 mb-12>
      <!--PC-->
      <v-layout wrap class="hidden-sm-and-down">
        <v-flex md7 lg7>
          <h3 class="cases-h3">项目案例</h3>
          <p class="cases-p">德国玛娅家居从进入中国市场开始，多年来一直在工程精装房市场不断发力深耕，与多家房地产企业达成了良好的战略合作关系，过硬的产品品质，得到了合作伙伴的信任与支持，让德国玛娅家居全屋定制化产品的身影出现在越来越多的高端精装楼盘中。</p>
        </v-flex>
        <v-flex md5 lg5>
        </v-flex>
        <v-layout wrap v-if="cases">
          <v-flex xs12 md3 v-for="(item, i) in cases" :key="item.key" :class="'case-flex case-flex' + i%4">
            <a :href="'/case/' + item.id">
            <!-- <div class="cases-main"> -->
            <div class="cases-card">
              <div class="cases-pic-div">
                <img :src="item.img" class="cases-pic"/>
                <h3 class="cases-title">{{item.title}}</h3>
              </div>
            </div>
            </a>
          </v-flex>
        </v-layout>
        <!--<v-flex md12 lg12 mt-12>
          <template>
            <vue-seamless-scroll
              :data="cases"
              :class-option="classOption"
              class="cases-warp"
            >
              <ul class="cases-ul" v-if="cases">
                <li v-for="item in cases" :key="item.id" class="cases-li">
                  <div class="cases-main">
                    <div class="cases-pic-div">
                      <img :src="item.img" class="cases-pic"/>
                      <h3 class="cases-title">{{item.title}}</h3>
                    </div>
                    <v-btn
                      color="black"
                      width="40"
                      height="40"
                      fab
                      depressed
                      class="btn-entry"
                      :href="'/case/' + item.id"
                    >
                      <v-icon large>mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </template>
        </v-flex>-->
      </v-layout>
      <!--移动端-->
      <v-layout wrap class="hidden-md-and-up">
        <v-flex xs12 sm12>
          <h3 class="cases-h3">项目案例</h3>
          <p class="cases-p">德国玛娅家居从进入中国市场开始，多年来一直在工程精装房市场不断发力深耕，与多家房地产企业达成了良好的战略合作关系，过硬的产品品质，得到了合作伙伴的信任与支持，让德国玛娅家居全屋定制化产品的身影出现在越来越多的高端精装楼盘中。</p>
        </v-flex>
        <v-flex xs12 sm12 mb-12 v-for="item in cases" :key="item.id">
          <a :href="'/case/' + item.id">
            <v-img class="cases-pic" :src="item.img"></v-img>
            <h3 class="cases-title-m">{{item.title}}</h3>
          </a>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
// import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  /*
  components: {
    vueSeamlessScroll
  },
  */
  data: () => ({
    catId: null,
    cases: [],
    totalPage: 1,
    page: 1,
    classOption: {
      // step: 1,
      limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
      hoverStop: true, // 是否开启鼠标悬停stop
      direction: 2, // 0向下 1向上 2向左 3向右
      openWatch: true, // 开启数据实时监控刷新dom
      singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
      singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
      waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
    }
  }),
  created () {
    this.catId = 18
    // this.catId = 14
    this.getCases(this.page, this.catId)
  },
  mounted: function () {
  },
  computed: {
    info () {
      return this.$store.getters.companyInfo
    }
  },
  watch: {
    page: {
      handler: function (val, oldVal) {
        this.getCases(val, this.catId)
      },
      deep: true
    }
  },
  methods: {
    getCases (page, cid) {
      this.https.get('cases', { page: page, cid: cid, pageSize: 100 }).then(response => {
        if (response.code === 0) {
          this.cases = response.data.data
          // this.$refs.seamlessScroll.reset()
          this.totalPage = response.data.last_page
          this.page = page
        }
      })
    }
  }
}
</script>
<style lang="css">
  @import '../css/case.css';
</style>
<style lang="scss" scoped>
  .cases-warp {
    height: 560px;
    margin: 0 auto;
    overflow: hidden;
    ul {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      &.cases-ul {
        display: flex;
        .cases-li {
          margin-right: 40px;
          height: 560px;
          max-height: 560px;
        }
      }
    }
  }
</style>
